import { Module } from 'vuex';
import { SimuladorState, state } from './state';
import { mutations } from './mutations';
import actions from './actions';
import { getters } from './getters';
import { RootState } from '../types';

export const simulador: Module<SimuladorState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};